import { render, staticRenderFns } from "./OrderButton.vue?vue&type=template&id=2796034e&scoped=true&"
import script from "./OrderButton.vue?vue&type=script&lang=js&"
export * from "./OrderButton.vue?vue&type=script&lang=js&"
import style0 from "./OrderButton.vue?vue&type=style&index=0&id=2796034e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796034e",
  null
  
)

export default component.exports